// extracted by mini-css-extract-plugin
export default {"faqsSection":"faqsSection__ZjI2N","itemCount":"itemCount__MjA4M"};